module.exports = __webpack_public_path__ + "static/media/9DESA6.d2d5e300.jpg";